import React from "react";
import { AddressService, Service } from "../api/models";

interface ServiceNameProps {
  addressService?: AddressService;
  service?: Service;
}

export function ServiceName(props: ServiceNameProps) {
  const { addressService, service } = props;
  if (!addressService && !service) return null;

  return (
    <span>
      {addressService?.name ?? service?.name}
      {addressService?.description ? " (" + addressService.description + ")" : null}
    </span>
  );
}
